import ReactOnRails from 'react-on-rails';

import marketingComponents from '../bundles/Marketing/registerComponents';

// Client-side registration + hydration for the marketing site.
ReactOnRails.register(marketingComponents);
